<template>
  <component
    :is="svgComponent"
    :svg-props="svgProps"
    :aspect-ratio="aspectRatio"
    :height="height"
    :width="width"
    :current-path="currentPath"
  />
</template>

<script>
import { pascalCase } from 'change-case'
// import { get } from 'lodash-es'

import components from '@/js/components/Shared/SvgSelect/SVG'

// import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
// import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'

export default {
  name: 'SvgSelect',
  components,
  props: {
    svg: {
      type: String,
      required: true,
    },
    svgProps: {
      type: Object,
      default: () => ({}),
    },
    aspectRatio: {
      type: String,
      default: 'none',
    },
    height: {
      type: [Number, String],
      default: '',
    },
    width: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      svgComponent: this.getSvgComponentName(this.svg),
    }
  },
  computed: {
    currentPath() {
      // const pathToLangUrl = `state.${STOREMODULES.APP}.${APP_CONFIG_CONSTANTS.PATHS.CURRENT_LANG_URL}`
      // const langUrl = get(this.$store, pathToLangUrl)
      // return langUrl ? langUrl.replace(/\/+$/, '') : ''
      const url = window.location.href.split('#')
      return url[0]
    },
  },
  watch: {
    svg(newSvg, oldSvg) {
      if (newSvg !== oldSvg) {
        this.svgComponent = this.getSvgComponentName(newSvg)
      }
    },
  },
  methods: {
    getSvgComponentName(svg) {
      const fallbackComponentName = 'FallbackIcon'
      const componentName = `${pascalCase(svg)}`

      return Object.keys(components).indexOf(componentName) < 0
        ? fallbackComponentName
        : componentName
    },
  },
}
</script>
